import React, { useState, useEffect, useRef} from 'react';
import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective, PdfExport,Selection, Toolbar, Resize } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import '../App.css';
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
import { ColumnDirective, ColumnsDirective, TreeGridComponent } from '@syncfusion/ej2-react-treegrid';
import VirtualizedSelect from 'react-virtualized-select';
import DatePicker from 'react-datepicker'; 
 
import Layout from './Layout.js';
 
import {useTaskListHook} from '../hook/TaskListHook.js'
const ProjectList =   () => {
  const [ganttChart,setGanttChart] = useState(null)

  const {message,setmessage,tipe,settipe,layout,AddParentTask,roleAccess,handleTimeline,inputRef,ChangeLayout,rows,dropdown,
          settings,taskFields,labelSettings,timelineSetting,toolbarOptions,toolbarClick,confirmTaskOpen,setConfirmTaskOpen,
          AddTask,typeList,setSelectedType,selectedType,taskName,handleTask,handleDate,taskDate,statusList,setSelectedStatus,selectedStatus,
          kemajuan,setKemajuan,confirmDeleteOpen,setConfirmDeleteOpen,handleDeleteConfirmation
        } = useTaskListHook(ganttChart);
  
    return (
      <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
  <div className='pd'><b>TASK LIST</b> </div>
 
  <div className="pd"  id='dialog-target'>
           <div style={{display:"flex", width:"100%"}}>
            <div style={{marginTop:5,marginBottom:10, width:"50%"}}>
                {layout == 'Task' && (
                        <button onClick={() => AddParentTask()} className='btn btn-primary' style={{width:150}} disabled={!roleAccess.CREATE}>ADD NEW TASK</button> 
                )}

                {layout == 'Gantt' && (
                    <div>
                        <button onClick={() => handleTimeline("month")} className='btn btn-primary' style={{width:150}}>Month</button>&nbsp; 
                        <button onClick={() => handleTimeline("week")} className='btn btn-primary' style={{width:150}}>Week</button>&nbsp; 
                        <button id='btnDay' ref={inputRef} onClick={() => handleTimeline("day")} className='btn btn-primary' style={{width:150}}>Day</button> &nbsp;
                        </div>
                )}
                
            </div>
            <div style={{marginTop:5,marginBottom:10, width:"50%",textAlign:"right", border:1,borderColor: "black"}}> <button onClick={() => ChangeLayout()} className='btn btn-info' style={{width:100}}>{layout == "Task" ? ("GANTT") : ("TASK") }</button></div>
            </div>
            
            {layout=="Task" && (
            <div>
              <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='100%' width='100%'  queryCellInfo={dropdown} enableCollapseAll={false} allowTextWrap={true} textWrapSettings={settings}>
                 <ColumnsDirective>
                    <ColumnDirective field='id' headerText='Task ID' width='50' textAlign='Right' isPrimaryKey={true} visible={false}/>
                    <ColumnDirective field='name' headerText='Task Name' width='150'/>
                    <ColumnDirective field='sebenarnya_mulai' headerText='Start Date' width='130' type="date" format={{ type:'date', format:'dd/MM/yyyy' }} textAlign='Right' />
                    <ColumnDirective field='sebenarnya_selesai' headerText='End Date' width='130'  type="date" format={{ type:'date', format:'dd/MM/yyyy' }}  textAlign='Right' />
                    <ColumnDirective field='statusname' headerText='Task Status' width='130'  textAlign='Right' />
                    
                    {/* <ColumnDirective field='levelname' headerText='Task Level' width='80' textAlign='Right'/> */}
                    <ColumnDirective field='Action' headerText='Add Sub Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Edit' headerText='Edit Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Delete' headerText='Delete Task' width='100' textAlign='Right'/>
                </ColumnsDirective>
            </TreeGridComponent>;
            </div>
            )}
             {layout=="Gantt" && (
            <div>
                <GanttComponent dataSource={rows} treeColumnIndex={1} height="100%"  width="100%" taskFields={taskFields} allowResizing={true}  labelSettings={labelSettings}  timelineSettings={timelineSetting} includeWeekend={false} highlightWeekends={true} workWeek={["Monday", "Tuesday", "Wednesday","Thursday","Friday"]}   toolbar={toolbarOptions} allowPdfExport={true} toolbarClick={toolbarClick}  ref={gantt => setGanttChart(gantt)}>
                <ColumnsDirective>
                    <ColumnDirective field='id' width='0' visible={false} />
                    <ColumnDirective field='name' headerText='Task Name'  width='200'/>
                    <ColumnDirective field='sebenarnya_mulai' headerText='Start Date' format={{ type:'date', format:'dd/MM/yyyy' }}/>
                    <ColumnDirective field='sebenarnya_selesai' headerText='End Date' format={{ type:'date', format:'dd/MM/yyyy' }}/>
                    <ColumnDirective field='kemajuan' headerText='Progress'/>
                    <ColumnDirective field='statusname' headerText='Status'/>
                </ColumnsDirective>
                {/* <HolidaysDirective>
                <HolidayDirective from='10/14/2024' label='Local Holiday' cssClass='e-custom-holiday'></HolidayDirective>
                    </HolidaysDirective> */}
                        <Inject services={[DayMarkers,Toolbar, PdfExport, Selection, Resize]} />
                </GanttComponent>
            </div>
             )}
            <Modal
        open={confirmTaskOpen}
        onClose={() => setConfirmTaskOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals' >
          {/* <Typography id="modal-modal-title">
            <h4>Detail</h4>
          </Typography> */}
          
          <Typography id="modal-modal-description">
            <form onSubmit={AddTask} role="form">
            <div class="row">
            <div class="col-md-12">
            <label>Type</label>
            <VirtualizedSelect
                         options={typeList}
                         onChange={(option) => setSelectedType(option.value)}
                         value={selectedType}
                        clearable={false}
                        searchable={true}
                         placeholder="Type"
                        required
                    /> 
            </div>
             </div>
          <div class="row">
            <div class="col-md-12">
                <label>Task Name</label>
                <input
                      type="text"
                      className="form-control"
                      placeholder="Task Name"
                      required
                      value={taskName}
                      onChange={(e) => handleTask(e.target.value)}
                    />
            </div>
             
         </div>
         {selectedType == 1 && (
            <div>
         
         <div class="row">
            <div class="col-md-6">
                <label>Start Date</label><br></br>
                <DatePicker 
                            showIcon
                            selected={taskDate[0]}
                           onChange={(date) => handleDate(date,0)}
                            dateFormat="yyyy-MM-dd"
                            required
                             className="form-control"
                        /> 
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>End Date</label><br></br>
                    <DatePicker 
                         showIcon
                         selected={taskDate[1]}
                           onChange={(date) => handleDate(date,1)}
                            dateFormat="yyyy-MM-dd"
                            required
                             className="form-control"
                             
                        /> 

                </div>


                
            </div>
         </div>

         <div class="row">
            <div class="col-md-6">
            <label>Status</label>
            <VirtualizedSelect
                        options={statusList}
                        onChange={(option) => setSelectedStatus(option)}
                        value={selectedStatus}
                        clearable={false}
                        searchable={true}
                         placeholder="Status"
                        required
                    /> 
            </div>
            <div class="col-md-6">
            <label>Progress (%)</label>
            <input
                      type="number"
                      className="form-control"
                      placeholder="Kemajuan"
                      max={100}
                      min={0}
                      value={kemajuan}
                      onChange={(e) => setKemajuan(e.target.value)}
                      required
                    />
            </div>
            {/* <div class="col-md-6">
            <label>Level</label>
            <VirtualizedSelect
                         options={delegasiList}
                         onChange={(option) => setSelectedDelegasi(option)}
                        value={selectedDelegasi}
                        placeholder="Level"
                        clearable={false}
                        searchable={true}
                        required
                    /> 
            </div> */}
         </div>
         <div class="row">
           
           
         </div>
         </div>
)} 
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
            <button type="submit" className="btn btn-primary">ADD TASK</button>
                 </div>
            </div>
           
         </div>
         </form>
        
          </Typography>
        </Box>
</Modal>

      <Modal
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
      <Box className='modals'  >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h3>Delete   {taskName}</h3>
          </Typography>
          <Typography id="modal-modal-description">
            <p>Are you sure you want to delete this data?</p>
            <button onClick={handleDeleteConfirmation} className='submit-button'>
              Yes
            </button>
            &nbsp;
            <button
              onClick={() => setConfirmDeleteOpen(false)}
              className='close-button'
            >
              No
            </button>
          </Typography>
        </Box>
      </Modal>  
    </div>
</Layout>

       
    );
}
 

export default ProjectList;